module.exports = __webpack_public_path__ + "img/buy.f98498ec.png";